import { definePreset } from "@primevue/themes";
import Aura from "@primevue/themes/aura";

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: "{amber.50}",
      100: "{amber.100}",
      200: "{amber.200}",
      300: "{amber.300}",
      400: "{amber.400}",
      500: "{amber.500}",
      600: "{amber.600}",
      700: "{amber.700}",
      800: "{amber.800}",
      900: "{amber.900}",
      950: "{amber.950}",
    },
    secondary: {
      50: "{gray.50}",
      100: "{gray.100}",
      200: "{gray.200}",
      300: "{gray.300}",
      400: "{gray.400}",
      500: "{gray.500}",
      600: "{gray.600}",
      700: "{gray.700}",
      800: "{gray.800}",
      900: "{gray.900}",
      950: "{gray.950}",
    },
    colorScheme: {
      light: {
        // primary: {
        //   color: "{amber.400}",
        //   inverseColor: "#000000",
        //   hoverColor: "{amber.500}",
        //   activeColor: "{amber.800}",
        //   contrastColor: "#000000",
        //   borderColor: "{amber.400}",
        // },
      },
      dark: {
        // primary: {
        //   color: "{amber.400}",
        //   inverseColor: "#000000",
        //   hoverColor: "{amber.500}",
        //   activeColor: "{amber.800}",
        //   contrastColor: "#000000",
        //   borderColor: "{amber.400}",
        // },
        // secondary: {
        //   color: "{gray.400}",
        //   contrastColor: "#ffffff",
        // },
      },
    },
    formField: {
      paddingX: "0.75rem",
      paddingY: "0.5rem",
      borderRadius: "{border.radius.md}",
      focusRing: {
        width: "0",
        style: "none",
        color: "transparent",
        offset: "0",
        shadow: "none",
      },
      transitionDuration: "{transition.duration}",
    },
  },
  components: {
    button: {
      labelFontWeight: "400",
      colorScheme: {
        light: {
          root: {
            primary: {
              color: "black",
              background: "{amber.500}",
              hoverColor: "black",
              hoverBackground: "{amber.600}",
              borderColor: "transparent",
              hoverBoarderColor: "transparent",
            },
            secondary: {
              color: "white",
              background: "{gray.950}",
              hoverColor: "white",
              hoverBackground: "{gray.700}",
              borderColor: "transparent",
              hoverBoarderColor: "transparent",
            },
          },
          outlined: {
            primary: {
              color: "black",
              background: "transparent",
              hoverColor: "{amber.900}",
              borderColor: "{amber.800}",
              hoverBoarderColor: "{amber.900}",
            },
          },
        },
        dark: {
          root: {
            secondary: {
              color: "{gray.950}",
              background: "{gray.400}",
              hoverColor: "{gray.950}",
              hoverBackground: "{gray.200}",
              borderColor: "transparent",
              hoverBoarderColor: "transparent",
            },
            primary: {
              color: "{amber.950}",
              background: "{amber.500}",
              hoverColor: "{amber.950}",
              hoverBackground: "{amber.300}",
              borderColor: "transparent",
              hoverBoarderColor: "transparent",
            },
          },
          outlined: {
            primary: {
              color: "{amber.500}",
              background: "transparent",
              hoverColor: "{amber.950}",
              borderColor: "{amber.500}",
              hoverBoarderColor: "{amber.500}",
            },
          },
        },
      },
    },
  },
});

export default {
  preset: MyPreset,
  options: {
    darkModeSelector: ".p-dark",
  },
};
